import { Eye, EyeOff } from "react-feather";
import { Link } from "react-router-dom";

const ActiveButton = ({
  toggle = () => null,
  isActive = true
}) => {
  const button = Boolean(isActive) ? <Eye size={24} color="green" /> : <EyeOff size={24} color="red" />

  return (
    <Link
      onClick={(e) => {
        e.preventDefault();
        toggle();
      }}
    >
      {button}
    </Link>
  );
};

export default ActiveButton;
